import { InjectionToken } from '@angular/core';

/**
 * Bridge to AngularJS `$location`.
 *
 * Used by HelpersService and other services that need to interact with URL/routing.
 * When consumers migrate to Angular 18, use `Router` directly instead.
 */
export interface ILocationPort {
  protocol(): string;
  host(): string;
  port(): number;
  path(): string;
  path(path: string): ILocationPort;
  search(): Record<string, unknown>;
  search(search: Record<string, unknown> | string): ILocationPort;
  hash(): string;
  hash(hash: string): ILocationPort;
  absUrl(): string;
  url(): string;
  url(url: string): ILocationPort;
}

export const LOCATION_PORT = new InjectionToken<ILocationPort>('LOCATION_PORT');
